export const RESOURCE_TYPE = 'RESOURCE_TYPE_GIC_SMART_FIELDS';
export const RESOURCE_KEY = 'gsf-opt-out-resource-key'; // value is global for user

export const STORE_KEY = 'gic-smart-fields-feature';

export const PACKAGE_NAME = 'jiraRouterResourcesGicSmartFields';
